(function(angular){
	'use strict';

	angular
		.module('featuresModule')
		.factory('featuresFactory', [
			'$filter',
			'localStorageFactory',
			'mixpanelFactory',
			'moment',
			'urlFactory',
			FeaturesFactoryFunction
		]);

	function FeaturesFactoryFunction(
		$filter,
		localStorageFactory,
		mixpanelFactory,
		moment,
		urlFactory
	) {

		var featuresEndpoint = '/account/features/features.json';
		var factory = {
			dismiss: dismiss,
			getAccountFeatures: getAccountFeatures,
			getPinnedFeature: getPinnedFeature
		};

		return factory;

		function getDismissalKey(pinnedFeatureType) {
			return 'com.fundrise.dashboard.' + pinnedFeatureType + '.dismissUntil';
		}

		function dismiss(pinnedFeature) {
			var currentDateTime = moment();
			if(angular.isDefined(pinnedFeature)) {
				var dismissalKey = getDismissalKey(pinnedFeature.type);
				var dismissUntilTimestamp = currentDateTime.add(pinnedFeature.pinnedFeatureDismissalPeriod, 'days').toISOString();

				localStorageFactory.setItem(dismissalKey, dismissUntilTimestamp);
				pinnedFeature.isDismissed = true;
				mixpanelFactory.track('Pinned Feature Dismissed', {
					type: pinnedFeature.type
				});
			}
		}

		function isDismissed(pinnedFeature) {
			var isDismissed = false;

			if(angular.isDefined(pinnedFeature)) {
				var currentDateTime = moment();
				var dismissalKey = getDismissalKey(pinnedFeature.type);
				var dismissUntilTimestamp = localStorageFactory.getItem(dismissalKey);
				if(angular.isDefined(dismissUntilTimestamp)) {
					dismissUntilTimestamp = moment(dismissUntilTimestamp);
					isDismissed = dismissUntilTimestamp.diff(currentDateTime, 'days', true) >= 0;
				}
			}

			return isDismissed;
		}

		function getAccountFeatures(){
			return urlFactory.getPromise(featuresEndpoint).then(function(response) {
				return {
					available: $filter('filter')(response.data, { 'accountFeatureStatus': 'AVAILABLE', 'showAccountFeature' : true }, true),
					unavailable: $filter('filter')(response.data, { 'accountFeatureStatus': 'UNAVAILABLE', 'showAccountFeature' : true }, true),
					complete:  $filter('filter')(response.data, { 'accountFeatureStatus': 'COMPLETE', 'showAccountFeature' : true }, true)
				};
			});
		}

		function isPinnedFeature(feature){
			if(feature.showPinnedFeature && !isDismissed(feature)) {
				return feature.accountFeatureStatus === 'AVAILABLE' || feature.type==='IPO_THANK_YOU';
			}

			return false;
		}

		function getPinnedFeature(){
			return urlFactory.getPromise(featuresEndpoint).then(
				function(response) {
					var features = response.data;
					features = $filter('filter')(features, isPinnedFeature, true);
					features = $filter('orderBy')(features, 'priorityIndex', false);
					if(features[0]) {
						mixpanelFactory.track('Pinned Feature Shown', {
							type: features[0].type
						});
					}
					return features[0];
				});
		}
	}
})(window.angular);